import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import { useLocation } from 'react-router-dom';
import Sidenav from './SideNavLayout/Sidenav';

const Layout = ({ children }) => {
  const location = useLocation()
  const fromSignup = location.state
  const [sidenav, setSidenav] = useState(false)
  const toggleSidenav = () =>{
    setSidenav((prev) => !prev)
    console.log(sidenav)
  }
  return (
    <div>
      {sidenav ? (
        <div className='flex'>
          <Sidenav/>
          <main className="flex-grow">
            <Header sidenav={sidenav} toggleSidenav={toggleSidenav} />
            {children} {/* This renders the page content passed as children */}
          </main>
        </div>
      ): (
        <div className='flex flex-col min-h-screen'>
          <Header />
          <main className="flex-1 pt-16 pb-16 overflow-auto">
            {children} {/* This renders the page content passed as children */}
          </main>
          {!fromSignup && (
              <Footer />
          )}
        </div>
      )}
  </div>
)};

export default Layout;
